import React from "react"
import displayName from "utils/displayName"
import CachedQueryParamsContextProvider from "../CachedQueryParamsContextProvider"

const withCachedQueryParamsContext = (WrappedComponent) => {
  const WithCachedQueryParamsContext = (props) => (
    <CachedQueryParamsContextProvider>
      <WrappedComponent {...props} />
    </CachedQueryParamsContextProvider>
  )

  WithCachedQueryParamsContext.displayName = `withCachedQueryParamsContext(${displayName(WrappedComponent)})`

  return WithCachedQueryParamsContext
}

export default withCachedQueryParamsContext
